import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import { BottomNav } from '../components/BottomNav';
import logoNav from '../assets/logo_brandstarter.png';

const css = `
  .mm { --g:#173B34; --o:#E4572E; --c:#F6F2EC; --line:#E3DCCF; min-height: 100vh; background: var(--c); font-family: 'Inter', system-ui, sans-serif; color: #222; }
  .mm-top { background: #fff; border-bottom: 1px solid var(--line); height: 60px; padding: 0 16px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 100; }
  .mm-top img { height: 32px; width: auto; cursor: pointer; }
  .mm-wrap { max-width: 680px; margin: 0 auto; padding: 22px 16px 40px; }
  .mm-hero { background: var(--g); color: #F6F2EC; border-radius: 22px; padding: 24px 22px; }
  .mm-kick { font-size: 10.5px; letter-spacing: .14em; text-transform: uppercase; font-weight: 700; opacity: .7; }
  .mm-name { font-size: 30px; font-weight: 800; line-height: 1.1; margin-top: 6px; letter-spacing: -0.01em; }
  .mm-raison { font-size: 15.5px; line-height: 1.5; margin-top: 14px; opacity: .95; }
  .mm-prog { height: 8px; border-radius: 99px; background: rgba(255,255,255,.2); margin-top: 18px; overflow: hidden; }
  .mm-prog i { display: block; height: 100%; background: var(--o); border-radius: 99px; }
  .mm-progtxt { font-size: 12.5px; margin-top: 8px; opacity: .8; }
  .mm-promise { background: var(--o); color: #fff; border-radius: 20px; padding: 20px 22px; margin-top: 14px; }
  .mm-promise p { font-size: 20px; font-weight: 800; line-height: 1.3; margin: 8px 0 0; }
  .mm-sec { margin-top: 26px; }
  .mm-h { font-size: 12px; letter-spacing: .13em; text-transform: uppercase; font-weight: 800; color: var(--g); margin: 0 0 10px 4px; }
  .mm-card { background: #fff; border: 1px solid var(--line); border-radius: 18px; padding: 16px 18px; margin-bottom: 10px; }
  .mm-lab { font-size: 10.5px; letter-spacing: .12em; text-transform: uppercase; font-weight: 700; color: var(--o); margin-bottom: 5px; }
  .mm-txt { font-size: 15px; line-height: 1.55; color: #333; }
  .mm-chips { display: flex; flex-wrap: wrap; gap: 7px; }
  .mm-chip { background: #EAF1EE; color: var(--g); border-radius: 999px; padding: 7px 12px; font-size: 13.5px; font-weight: 600; }
  .mm-val { padding: 8px 0; border-bottom: 1px solid #F0EBE3; font-size: 14.5px; line-height: 1.5; }
  .mm-val:last-child { border-bottom: 0; }
  .mm-lock { background: #fff; border: 1.5px dashed var(--line); border-radius: 18px; padding: 16px 18px; margin-bottom: 10px; display: flex; align-items: center; justify-content: space-between; gap: 12px; }
  .mm-lock b { font-size: 15px; }
  .mm-lock span { font-size: 13px; color: #6b6b64; display: block; margin-top: 2px; }
  .mm-btn { min-height: 48px; border: 0; border-radius: 14px; padding: 0 18px; font-family: inherit; font-weight: 700; font-size: 14.5px; cursor: pointer; }
  .mm-btn.o { background: var(--o); color: #fff; }
  .mm-btn.g { background: var(--g); color: #F6F2EC; }
  .mm-btn.l { background: #fff; color: var(--g); border: 1.5px solid var(--line); }
  .mm-actions { display: flex; flex-direction: column; gap: 10px; margin-top: 26px; }
  .mm-cta { background: #fff; border: 1px solid var(--line); border-radius: 20px; padding: 20px; margin-top: 26px; text-align: center; }
  .mm-cta p { font-size: 14.5px; line-height: 1.5; color: #444; margin: 0 0 14px; }
  @media print { .mm-top, .bn, .bn-spacer, .mm-actions, .mm-cta, .mm-lock { display: none !important; } .mm { background: #fff; } }
`;

function keys(text) {
  const o = {};
  (text || '').split('\n').forEach(l => {
    const m = l.match(/^\s*([A-Z_0-9]+):\s*(.*)$/);
    if (m) o[m[1]] = m[2].replace(/\*\*/g, '').replace(/^\[|\]$/g, '').trim();
  });
  return o;
}
const list = (v) => (v || '').split('|').map(x => x.trim()).filter(Boolean);

function Card({ label, children }) { return children ? <div className="mm-card"><div className="mm-lab">{label}</div>{children}</div> : null; }
const Txt = ({ v }) => (v ? <div className="mm-txt">{v}</div> : null);
const Chips = ({ v }) => (list(v).length ? <div className="mm-chips">{list(v).map((x, i) => <span key={i} className="mm-chip">{x}</span>)}</div> : null);

function Lock({ num, titre, navigate }) {
  return (
    <div className="mm-lock">
      <div><b>{titre}</b><span>Pas encore complété</span></div>
      <button className="mm-btn o" onClick={() => navigate(`/module/${num}`)}>Faire</button>
    </div>
  );
}

export function MaMarquePage() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const ref = useRef(null);
  useEffect(() => { api.getDashboard().then(setData).catch(e => setError(e.message)); }, []);

  if (error) return <div className="mm"><style>{css}</style><div className="mm-wrap">{error}</div></div>;
  if (!data) return <div className="mm"><style>{css}</style><div className="mm-wrap">Chargement...</div></div>;

  const by = {};
  (data.reponses || []).forEach(r => { by[Number(r.numeroModule)] = keys(r.contenu); });
  const m1 = by[1], m2 = by[2], m3 = by[3], m4 = by[4], m5 = by[5];
  const done = [1, 2, 3, 4, 5].filter(n => by[n]).length;
  const brand = m1?.NOM_MARQUE || 'Ma marque';
  const share = async () => {
    const text = `${brand}${m4?.POS_PROMESSE ? ' : ' + m4.POS_PROMESSE : ''}`;
    try { if (navigator.share) await navigator.share({ title: `Plateforme de marque ${brand}`, text }); else { await navigator.clipboard.writeText(text); alert('Promesse copiée'); } } catch (e) { /* annulé */ }
  };

  return (
    <div className="mm">
      <style>{css}</style>
      <div className="mm-top">
        <img src={logoNav} alt="BrandStarter" onClick={() => navigate('/parcours')} />
        <button className="mm-btn l" style={{ minHeight: 40 }} onClick={() => navigate('/parcours')}>Parcours</button>
      </div>
      <div className="mm-wrap" ref={ref}>
        <div className="mm-hero">
          <div className="mm-kick">Plateforme de marque</div>
          <div className="mm-name">{brand}</div>
          {m3?.RAI_RAISON && <div className="mm-raison">{m3.RAI_RAISON}</div>}
          <div className="mm-prog"><i style={{ width: `${done * 20}%` }} /></div>
          <div className="mm-progtxt">{done} brique{done > 1 ? 's' : ''} sur 5 complétée{done > 1 ? 's' : ''}</div>
        </div>

        {m4?.POS_PROMESSE && <div className="mm-promise"><div className="mm-kick">Promesse de marque</div><p>{m4.POS_PROMESSE}</p></div>}

        <div className="mm-sec">
          <h2 className="mm-h">Fondations</h2>
          {m1 ? <>
            <Card label="Ton idée"><Txt v={m1.IDEE} /></Card>
            <Card label="Problème résolu"><Txt v={m1.PROBLEME_RESOLU} /></Card>
          </> : <Lock num={1} titre="1. Idée et vision" navigate={navigate} />}
          {m2 ? <Card label={`Ton client idéal : ${m2.PERSONA_PRENOM || ''}`}>
            <Txt v={[m2.PERSONA_AGE, m2.PERSONA_METIER, m2.PERSONA_LIEU].filter(Boolean).join(', ')} />
            {m2.PERSONA_CITATION && <div className="mm-txt" style={{ marginTop: 8, fontStyle: 'italic' }}>{m2.PERSONA_CITATION}</div>}
          </Card> : <Lock num={2} titre="2. Persona" navigate={navigate} />}
          {m3 ? <>
            <Card label="Mission"><Txt v={m3.RAI_MISSION} /></Card>
            <Card label="Vision à 5 ans"><Txt v={m3.RAI_VISION} /></Card>
            <Card label="Tes valeurs">{['RAI_VALEUR1', 'RAI_VALEUR2', 'RAI_VALEUR3'].map(k => m3[k] ? <div className="mm-val" key={k}><b>{list(m3[k])[0]}</b>{list(m3[k])[1] ? ` : ${list(m3[k])[1]}` : ''}</div> : null)}</Card>
          </> : <Lock num={3} titre="3. Raison d'être et valeurs" navigate={navigate} />}
        </div>

        <div className="mm-sec">
          <h2 className="mm-h">Positionnement</h2>
          {m4 ? <>
            <Card label="Phrase de positionnement"><Txt v={m4.POS_PHRASE} /></Card>
            <Card label="Ta différence clé"><Txt v={m4.POS_DIFF_CLE} /></Card>
            <Card label="Tes preuves"><Chips v={m4.POS_PREUVES} /></Card>
            <Card label="Alternatives et concurrents"><Chips v={m4.POS_CONCURRENTS} /></Card>
            <Card label="Catégorie"><Txt v={m4.POS_CATEGORIE} /></Card>
          </> : <Lock num={4} titre="4. Positionnement et promesse" navigate={navigate} />}
        </div>

        <div className="mm-sec">
          <h2 className="mm-h">Expression</h2>
          {m5 ? <>
            <Card label="Personnalité"><Chips v={m5.PERS_TRAITS} /></Card>
            <Card label="Ton de voix"><Txt v={m5.PERS_TON} /></Card>
            <Card label="Pitch en 30 secondes"><Txt v={m5.PERS_PITCH} /></Card>
            <Card label="Bio réseaux"><Txt v={m5.PERS_BIO} /></Card>
            <Card label="Accroche"><Txt v={m5.PERS_ACCROCHE} /></Card>
            <Card label="Mots que tu utilises"><Chips v={m5.PERS_MOTS_OUI} /></Card>
            <Card label="Mots que tu évites"><Chips v={m5.PERS_MOTS_NON} /></Card>
          </> : <Lock num={5} titre="5. Personnalité et voix" navigate={navigate} />}
        </div>

        <div className="mm-actions">
          <button className="mm-btn g" onClick={() => window.print()}>Enregistrer en PDF</button>
          <button className="mm-btn l" onClick={share}>Partager ma promesse</button>
        </div>

        <div className="mm-cta">
          <p>Envie d'un regard d'expert sur ta plateforme de marque ? Stratvente te donne un avis personnalisé.</p>
          <a href="https://stratvente.fr/rdv" target="_blank" rel="noreferrer"><button className="mm-btn o" style={{ width: '100%' }}>Demander un avis à Stratvente</button></a>
        </div>
      </div>
      <BottomNav />
    </div>
  );
}
